
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
export default Vue.extend({
    mixins: [AppMixin],

    name: 'MissingInfoBanner',
    data() {
        return {
            alert: true,
        }
    },
    computed: {
        missingPhone() {
            return this.currentUser && this.currentUser.attributes.mobileNumber === null
        },
        missingEmail() {
            return this.currentUser && this.currentUser.attributes.primaryEmail === null
        },
        isMissingInfo() {
            return this.missingPhone || this.missingEmail
        },
    },
    methods: {
        closeAlert() {
            this.alert = false
        },
    },
})
